// COUNTRY FIELD SELECTOR
import { Country } from "@utils/typescript/model/country/country.ts";
import { tryCatch } from "@utils/typescript/try-catch.ts";

window.addEventListener("load", handleCountryFieldSelector);

async function handleCountryFieldSelector() {
  const countryFields: NodeListOf<HTMLSelectElement> =
    document.querySelectorAll('select[name*="country"]');
  if (countryFields.length === 0) return;

  const result = await getAvailableCountries();
  if (result.error || !result.data.ok) {
    countryFields.forEach((countryField) => {
      countryField.innerHTML = `<option value="Fallback" disabled selected>Error loading countries, using fallback</option>`;
      countryField.disabled = true;
    });

    return console.error(
      "Error loading countries",
      result.error,
      result.data?.statusText,
    );
  }

  const countries: Array<Country> = await result.data.json();

  countryFields.forEach((countryField) => {
    const defaultSelectedCountry = countryField.getAttribute(
      "data-default-selected",
    );

    countryField.innerHTML = countries
      .map(
        (country) =>
          `<option
        value="${country.countryCode}"
        ${defaultSelectedCountry?.toUpperCase() === country.countryCode ? "selected" : ""}
        data-tenant="${country.tenant}"
        data-locale="${country.locale}">
        ${country.countryName}
      </option>`,
      )
      .join("");

    document.dispatchEvent(new CustomEvent("input.country-codes-ready"));
  });

  // HELPER
  async function getAvailableCountries() {
    return await tryCatch(fetch("/order/get-countries"));
  }
}
